export default __webpack_public_path__ + "static/29-9fdeddd331fe2d053c439d493a230c37.jpg";